var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39336",
    "data-name": "Group 39336",
    transform: "translate(-954 -3484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1302",
    "data-name": "Ellipse 1302",
    transform: "translate(954 3484)",
    fill: "#fff",
    stroke: "#7042c1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "graduation-student-icon",
    transform: "translate(961 3489.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68470",
    "data-name": "Path 68470",
    d: "M7.679,6.771a.2.2,0,0,0-.014.075.212.212,0,0,0,.425,0,.209.209,0,0,0-.022-.094,1.431,1.431,0,0,1,.281.061.076.076,0,0,0,.094-.059.089.089,0,0,0-.052-.107,1.462,1.462,0,0,0-.459-.075,1.443,1.443,0,0,0-.453.075.088.088,0,0,0-.052.107.075.075,0,0,0,.094.059,1.319,1.319,0,0,1,.158-.042ZM8.7,10.61a7.712,7.712,0,0,1-.472-.643,2.109,2.109,0,0,1-2.908-.06.258.258,0,0,0-.02.029c-.13.19-.276.406-.42.586.656,3.462,3.408,3.537,3.82.088Zm-.264-.829c.1.14.2.292.3.432.718.619,2.77.748,3.536,1.175a2.02,2.02,0,0,1,.643.545,3.956,3.956,0,0,1,.642,1.8.709.709,0,0,1-.743.694H.743A.71.71,0,0,1,0,13.728a3.961,3.961,0,0,1,.642-1.8,2.02,2.02,0,0,1,.643-.545C2.014,10.982,3.9,10.846,4.7,10.3c.126-.162.256-.353.371-.523l.035-.052.029.008a5.684,5.684,0,0,1-.987-1.4.179.179,0,0,1,0-.035h0V7.978h0a.16.16,0,0,1-.053,0c-.325-.048-.5-.446-.542-.826a1.541,1.541,0,0,1-.006-.3A.952.952,0,0,1,3.6,6.584a.294.294,0,0,1,.338-.223.359.359,0,0,1,.208.122V6.349c-.183-.1-.256-.447-.278-.771H3.865v-.13c0-.08,0-.155,0-.223V3.29L6.954,4.475,9.967,3.29V5.209h.011q-.007.044-.011.092v.278h-.02c-.021.307-.061.637-.286.777a.3.3,0,0,1,.3.228.961.961,0,0,1,.056.266,1.746,1.746,0,0,1-.006.3c-.042.381-.217.779-.542.826-.05.007-.042-.014-.042.049a3.777,3.777,0,0,1-.991,1.756ZM6.894,0l5.239,1.982-.41.163v1.42a.408.408,0,0,1,.185.347.38.38,0,1,1-.759,0,.409.409,0,0,1,.187-.347V2.3l-.669.266v1a.408.408,0,0,1,.185.347.38.38,0,1,1-.759,0,.408.408,0,0,1,.185-.347V2.719L6.894,4.066,1.732,2.043,6.894,0ZM6.111,9.262a.118.118,0,1,1,.123-.2,1.046,1.046,0,0,0,.56.171,1,1,0,0,0,.533-.171.118.118,0,1,1,.127.2,1.233,1.233,0,0,1-.658.207,1.293,1.293,0,0,1-.684-.205ZM8.169,5.514c-1.3-.036-2.56-.041-3.785.029l-.07.018V8.3C5.96,11.47,8.523,10.5,9.246,8.028V5.551c-.4.006-.756-.011-1.077-.038ZM9.443,7.807V6.818c.042-.18.121-.272.21-.289.309-.058.259,1.21-.21,1.278Zm-2.926.437a.1.1,0,0,1-.012-.138.1.1,0,0,1,.138-.013.228.228,0,0,0,.142.063.232.232,0,0,0,.148-.065.1.1,0,0,1,.126.153.391.391,0,0,1-.542,0Zm-2.4-.437V6.818c-.042-.18-.121-.272-.21-.289-.309-.058-.259,1.21.21,1.278Zm1.1-.973a.074.074,0,0,1-.1-.054.088.088,0,0,1,.047-.109,1.223,1.223,0,0,1,.46-.086,1.372,1.372,0,0,1,.458.086.088.088,0,0,1,.049.108.075.075,0,0,1-.1.056,1.485,1.485,0,0,0-.151-.046.235.235,0,0,1,.008.058.212.212,0,0,1-.425,0,.2.2,0,0,1,.016-.081,1.094,1.094,0,0,0-.271.068Z",
    fill: "#7042c1",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentboxIcon);
export default __webpack_public_path__ + "static/media/studentboxIcon.66800cf502e67a1fef811bb6e1269980.svg";
export { ForwardRef as ReactComponent };